import { Device } from '../../helpers'
import { getStyles } from './helpers/getStyles'
import { NativeDataType } from '../enums/NativeDataType'

const nativeGridStyles = {
  display: 'grid',
  'grid-template-rows': 'repeat(4, max-content) minmax(80px, min-content)',
  gap: '10px',
  width: '300px',
  'max-height': '600px'
}
const color = '#2A2F2F'
const reset = {
  background: 'none!important',
  'box-shadow': 'none!important',
  border: 'none!important'
}

const imageStyles = {
  ...reset,
  width: '300px',
  height: '300px',
  'grid-column-start': 1,
  'grid-row-start': 1,
  'align-items': 'center',
  'align-self': 'center',
  'justify-content': 'center',
  overflow: 'hidden',
  position: 'relative',
  'background-repeat': 'no-repeat!important',
  'background-position': 'center center!important',
  'background-size': 'contain!important',
  'border-top': '8px solid #bebebe',
  'border-bottom': '8px solid #bebebe',
  'border-radius': '5px'
}

const videoStyles = {
  'grid-column-start': 1,
  'grid-row-start': 1
}

const imageAnchorStyles = {
  ...reset,
  height: '100%',
  width: '100%',
  display: 'block',
  position: 'absolute',
  top: 0,
  left: 0
}

const titleStyles = {
  ...reset,
  margin: 0,
  'line-height': 'initial',
  'letter-spacing': 'initial',
  color,
  'font-family': 'inherit',
  'font-weight': 'bold',
  'font-size': '18px',
  'text-transform': 'none',
  'text-decoration': 'none'
}

const titleWrapperStyles = {
  ...reset,
  margin: 0,
  'grid-row-start': 3,
  'grid-column-start': 1,
  'align-items': 'left',
  overflow: 'hidden',
  '-webkit-line-clamp': 2,
  '-webkit-box-orient': 'vertical'
}

const sponsorStyles = {
  ...reset,
  'grid-row-start': 2,
  'grid-column-start': 1,
  'text-transform': 'emphasis',
  'font-size': '14px',
  'font-weight': 100,
  'text-decoration': 'none',
  color
}

const ctaStyles = {
  ...reset,
  'grid-row-start': 5,
  'grid-column-start': 1,
  'align-self': 'start',
  'text-align': 'center',
  padding: Device.isMobileOrTablet ? 'auto 10px' : '8px 0px',
  'margin-bottom': '10px 0'
}

const ctaAnchorStyles = {
  ...reset,
  'text-decoration': 'none',
  'background-color': '#eee!important',
  padding: '12px 48px',
  color,
  'font-weight': '300',
  'text-align': 'center',
  'font-size': '14px',
  'border-radius': '35px'
}

const bodyStyles = {
  ...reset,
  'align-self': 'center',
  'grid-row-start': 4,
  'grid-column-start': 1,
  'line-height': 'initial',
  'letter-spacing': 'initial',
  'font-size': '15px',
  'font-weight': '100',
  overflow: 'hidden',
  '-webkit-line-clamp': 3,
  '-webkit-box-orient': 'vertical'
}

const mobileMaxWidth = 768

bodyStyles['margin'] = 0
titleStyles['margin'] = 0
imageStyles['min-height'] = '175px'

export const template = `
<div style="${getStyles(nativeGridStyles)}">

  <div style="${getStyles(
    videoStyles
  )}" data-native-size="[300, 250]" data-native-type="${NativeDataType.video}">
  </div>

  <a style="${getStyles(
    imageStyles
  )}" data-native-min-size="[100, 100]" data-native-type="${
  NativeDataType.image
}">
  </a>
  <a style="${getStyles(sponsorStyles)}" data-native-type="${
  NativeDataType.sponsoredBy
}">A message from </a>
  <h3 style="${getStyles(
    titleWrapperStyles
  )}" data-native-len="80" data-native-d-len="120">
    <a style="${getStyles(titleStyles)}" data-native-type="${
  NativeDataType.title
}"></a>
  </h3>
  <p style="${getStyles(bodyStyles)}"  data-native-type="${
  NativeDataType.body
}" data-native-len="140" data-native-d-len="340"></p>
  <div style="${getStyles(ctaStyles)}">
    <a style="${getStyles(ctaAnchorStyles)}" data-native-type="${
  NativeDataType.clickUrl
}"><span data-native-type="cta"></span></a>
  </div>
</div>
`
